import { useState, useEffect, useCallback } from 'react';
import { Fingerprint, RefreshCw } from 'lucide-react';

const isCapacitorNative = () => !!window.Capacitor?.isNativePlatform?.();

export default function BiometricLock({ hasSession, onUsePassword, children }) {
  const [status, setStatus] = useState('checking');

  const attempt = useCallback(async () => {
    setStatus('prompting');
    try {
      const { BiometricAuth } = await import('@aparajita/capacitor-biometric-auth');
      const result = await BiometricAuth.checkBiometry();
      if (!result.isAvailable) {
        setStatus('unlocked');
        return;
      }
      await BiometricAuth.authenticate({
        reason: 'Unlock KiranaFlow',
        cancelTitle: 'Use Password',
        allowDeviceCredential: true,
      });
      setStatus('unlocked');
    } catch {
      setStatus('failed');
    }
  }, []);

  useEffect(() => {
    if (!isCapacitorNative() || !hasSession) {
      setStatus('unlocked');
      return;
    }
    attempt();
  }, [hasSession, attempt]);

  if (status === 'unlocked') return children;

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-6" style={{ background: '#0f172a' }}>
      <div className="flex flex-col items-center gap-4">
        <Fingerprint className="h-16 w-16" style={{ color: '#6d28d9', opacity: status === 'prompting' ? 0.5 : 0.9 }} />
        <p className="text-sm text-center px-8" style={{ color: 'rgba(203,213,225,0.7)' }}>
          {status === 'prompting' ? 'Verifying identity…' : 'Authentication failed.'}
        </p>
      </div>
      {status === 'failed' && (
        <div className="flex flex-col items-center gap-3">
          <button
            onClick={attempt}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium"
            style={{ background: 'linear-gradient(135deg,#7c3aed,#6d28d9)', color: '#fff' }}
          >
            <RefreshCw className="h-4 w-4" />
            Try again
          </button>
          <button
            onClick={onUsePassword}
            className="text-xs underline underline-offset-2"
            style={{ color: 'rgba(148,163,184,0.7)' }}
          >
            Sign in with password instead
          </button>
        </div>
      )}
    </div>
  );
}
